import { styled } from '@linaria/react';
import { layout, semantic, space } from '../../theme/tokens';

export const Outer = styled.div`
  position: relative;
  width: 100%;
  flex-shrink: 0;

  @media (min-width: ${layout.desktopBreakpoint}) {
    height: 100%;
    padding: ${layout.horizontalPadding};
    box-sizing: border-box;
  }
`;

export const OuterSticky = styled.div`
  position: relative;
  width: 100%;
  flex-shrink: 0;

  @media (min-width: ${layout.desktopBreakpoint}) {
    height: 100%;
    padding: ${layout.horizontalPadding};
    box-sizing: border-box;
    position: sticky;
    top: 0;
  }
`;

export const ImageContainer = styled.div`
  position: relative;
  width: 100%;
  height: var(--image-frame-mobile-height, auto);
  overflow: hidden;

  @media (min-width: ${layout.desktopBreakpoint}) {
    height: var(--image-frame-desktop-height, 100%);
    border-radius: 20px;
  }
`;

export const Img = styled.img`
  width: 100%;
  height: 100%;
  display: block;
  object-fit: cover;
`;

export const Placeholder = styled.div`
  width: 100%;
  aspect-ratio: 16 / 9;
  background: ${semantic.bg.surfaceStrong};
  border-radius: inherit;
`;

export const Overlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  padding: ${space[6]};
  background: linear-gradient(rgba(0, 0, 0, 0.35), transparent);
  display: flex;
  align-items: center;
  justify-content: center;

  @media (min-width: ${layout.desktopBreakpoint}) {
    padding: ${space[8]};
    border-radius: 20px 20px 0 0;
    background: none;
  }
`;

export const BadgeContainer = styled.div`
  position: absolute;
  bottom: ${layout.horizontalPadding};
  left: ${space[4]};
  z-index: 2;

  @media (min-width: ${layout.desktopBreakpoint}) {
    bottom: ${space[5]};
    left: ${space[5]};
  }
`;
